var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./IndexFeatured.jinja');
require('./IndexFeatured.less');

module.exports = Base.extend({

    template: template,

    events: {
        'mouseenter .IndexFeatured-membersItem': 'onMouseEnter'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    onMouseEnter: function (e) {
        if (!app.settings.isDesktop) return;

        this.$('.IndexFeatured-membersItem').css('z-index', '');
        $(e.currentTarget).css('z-index', 1);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexFeatured/IndexFeatured.js
// module id = 180
// module chunks = 0